const STATES = {
  LOADED: 'loaded',
  ERROR: 'error',
  LOADING: 'loading',
  ENDING: 'ending',
  ENDING_LOADED: 'ending:loaded',
  ENDING_ERROR: 'ending:error',
};
export { STATES };
